import { render } from "./ProcessFlow.vue?vue&type=template&id=8a4c6262"
import script from "./ProcessFlow.vue?vue&type=script&lang=js"
export * from "./ProcessFlow.vue?vue&type=script&lang=js"

import "./ProcessFlow.vue?vue&type=style&index=0&id=8a4c6262&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__